export const generateDateFallbackTitle = (): string =>
  new Date()
    .toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
    .replace(",", "");

export const generateConversationTitle = (
  prompt: string,
  maxLength: number = 30,
  fallback: string = "New Conversation",
): string => {
  if (!prompt || prompt.trim().length === 0) {
    return fallback;
  }

  // Take the first non-empty line. Avoids treating punctuation inside markdown
  // constructs (e.g. "1." in "## 1. Title") as sentence terminators.
  const firstLine =
    prompt.split("\n").find((l) => l.trim().length > 0) ?? prompt;

  // Strip common markdown syntax so the result is clean plain text
  let title = firstLine
    .trim()
    .replace(/^#{1,6}(?!#)\s*/, "") // ## heading markers
    .replace(/\*+/g, "") // **bold** / *italic*
    .replace(/^[-*+]\s+/, "") // - unordered list marker
    .replace(/^\d+\.\s+/, "") // 1. ordered list marker
    .replace(/\s+/g, " ")
    .trim();

  // Truncate to max length
  if (title.length > maxLength) {
    title = title.substring(0, maxLength).trim();
    const lastSpace = title.lastIndexOf(" ");
    if (lastSpace > maxLength * 0.6) {
      title = title.substring(0, lastSpace);
    }
  }

  // Remove characters that fail GroupChatFormSchema's title regex
  title = title
    .replace(/[^a-zA-Z0-9._() -]/g, "")
    .replace(/\s+/g, " ")
    .trim();

  // Fallback if result is too short to pass schema validation (min 3 chars)
  if (title.length < 3) {
    return fallback;
  }

  return title;
};
